import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Check, X } from 'lucide-react';

const Step1SelectPlan = ({ selectedPlan, onSelectPlan }) => {
  const { isDark } = useTheme();

  const plans = [
    {
      key: 'free',
      name: 'FREE',
      subtitle: '30 DÍAS GRATIS',
      disabled: true,
      badge: 'INCLUIDO',
      included: [
        'VPN',
        'Routers Ilimitados',
        'Planes Ilimitados',
        'Puntos de Venta Ilimitados',
        'Vendedores Ilimitados',
        'Impresion carta/ticket',
        'Cortes',
        'Reportes',
        'Gestion PPPoE'
      ],
      notIncluded: [
        'Creador de Portales Cautivos',
        'Generador de Scripts',
        'Solucion MAC aleatoria'
      ]
    },
    {
      key: 'solo_vpn',
      name: 'SOLO VPN',
      included: [
        'Acceso VPN'
      ],
      notIncluded: [
        'Routers Ilimitados',
        'Planes Ilimitados',
        'Puntos de Venta Ilimitados',
        'Vendedores Ilimitados',
        'Impresion carta/ticket',
        'Cortes',
        'Reportes',
        'Gestion PPPoE',
        'Creador de Portales Cautivos',
        'Generador de Scripts',
        'Solucion MAC aleatoria'
      ]
    },
    {
      key: 'solo_hotspot',
      name: 'SOLO HOTSPOT',
      included: [
        'VPN',
        '1 Router',
        'Planes Ilimitados',
        'Puntos de Venta Ilimitados',
        '3 Vendedores',
        'Impresion carta/ticket',
        'Cortes',
        'Reportes'
      ],
      notIncluded: [
        'Gestion PPPoE',
        'Creador de Portales Cautivos',
        'Generador de Scripts',
        'Solucion MAC aleatoria'
      ]
    },
    {
      key: 'solo_pppoe',
      name: 'SOLO PPPOE',
      included: [
        'VPN',
        '1 Router',
        'Cortes',
        'Reportes',
        'Gestion PPPoE'
      ],
      notIncluded: [
        'Planes Ilimitados',
        'Puntos de Venta Ilimitados',
        'Vendedores Ilimitados',
        'Impresion carta/ticket',
        'Creador de Portales Cautivos',
        'Generador de Scripts',
        'Solucion MAC aleatoria'
      ]
    },
    {
      key: 'hotspot_pppoe',
      name: 'HOTSPOT + PPPOE',
      included: [
        'VPN',
        '1 Router',
        'Planes Ilimitados',
        'Puntos de Venta Ilimitados',
        '3 Vendedores',
        'Impresion carta/ticket',
        'Cortes',
        'Reportes',
        'Gestion PPPoE'
      ],
      notIncluded: [
        'Creador de Portales Cautivos',
        'Generador de Scripts',
        'Solucion MAC aleatoria'
      ]
    },
    {
      key: 'todo_incluido',
      name: 'TODO INCLUIDO',
      badge: 'POPULAR',
      included: [
        'VPN',
        'Routers Ilimitados',
        'Planes Ilimitados',
        'Puntos de Venta Ilimitados',
        'Vendedores Ilimitados',
        'Impresion carta/ticket',
        'Cortes',
        'Reportes',
        'Gestion PPPoE',
        'Creador de Portales Cautivos',
        'Generador de Scripts',
        'Solucion MAC aleatoria'
      ],
      notIncluded: []
    }
  ];

  return (
    <div>
      <div className="text-center mb-10">
        <h2 className={`text-4xl font-extrabold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
          Selecciona Tu Plan Ideal
        </h2>
        <p className={`text-lg ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
          Todos los planes incluyen <span className="font-bold text-green-600">30 días GRATIS</span> para probar
        </p>
      </div>

      {/* Grid de planes */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {plans.map((plan) => (
          <div
            key={plan.key}
            onClick={() => !plan.disabled && onSelectPlan(plan.key)}
            className={`rounded-2xl overflow-hidden cursor-pointer transition-all transform hover:scale-105 hover:shadow-2xl ${
              selectedPlan === plan.key 
                ? 'ring-4 ring-blue-500 shadow-2xl scale-105' 
                : 'shadow-lg'
            } ${
              plan.disabled 
                ? 'opacity-60 cursor-not-allowed' 
                : ''
            } ${
              isDark ? 'bg-gray-800 border border-gray-700' : 'bg-white'
            }`}
          >
            {/* Header del Plan */}
            <div className={`p-6 text-center relative ${
              plan.key === 'free' 
                ? 'bg-gradient-to-br from-green-600 to-emerald-600'
                : plan.key === 'todo_incluido'
                ? 'bg-gradient-to-br from-purple-600 to-pink-600'
                : 'bg-gradient-to-br from-blue-600 to-indigo-600'
            }`}>
              {/* Badge */}
              {plan.badge && (
                <div className={`absolute top-2 right-2 px-3 py-1 rounded-full text-xs font-bold ${
                  plan.badge === 'POPULAR' 
                    ? 'bg-yellow-400 text-gray-900 animate-pulse' 
                    : 'bg-green-400 text-gray-900'
                }`}>
                  {plan.badge}
                </div>
              )}

              <h3 className="text-2xl font-extrabold text-white mb-2">
                {plan.name}
              </h3>
              {plan.subtitle && (
                <p className="text-sm text-white/90 font-medium">
                  {plan.subtitle}
                </p>
              )}
            </div>

            {/* Items List */}
            <div className="p-6 space-y-3">
              {/* Items incluidos */}
              {plan.included.map((item, index) => (
                <div key={`inc-${index}`} className="flex items-center gap-2">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
                  <span className={`text-sm ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                    {item}
                  </span>
                </div>
              ))}
              
              {/* Items NO incluidos */}
              {plan.notIncluded.map((item, index) => (
                <div key={`exc-${index}`} className="flex items-center gap-2">
                  <X className="w-5 h-5 text-gray-400 flex-shrink-0" />
                  <span className={`text-sm ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                    {item}
                  </span>
                </div>
              ))}
            </div>

            {/* Indicador de selección */}
            {selectedPlan === plan.key && (
              <div className="bg-blue-600 text-white text-center py-3 font-bold">
                ✓ SELECCIONADO
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Mensaje de ayuda */}
      {!selectedPlan && (
        <div className={`text-center p-4 rounded-xl ${
          isDark ? 'bg-blue-900/30 border border-blue-700' : 'bg-blue-100 border border-blue-300'
        }`}>
          <p className={`text-lg font-semibold ${isDark ? 'text-blue-300' : 'text-blue-800'}`}>
            👆 Selecciona un plan para continuar
          </p>
        </div>
      )}
    </div>
  );
};

export default Step1SelectPlan;
